// extracted by mini-css-extract-plugin
export default {"replies":"tweet-replies_replies__6LebM","link":"tweet-replies_link__gBAfW","text":"tweet-replies_text__SSuqI"};